import { useRef, useState, memo } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const ImageLoader = memo(function (props) {
  // initial state: image loaded stage

  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  // const [imgLoaded, setImgLoaded] = useState(false);
  const imageRef = useRef(null);
  // image onLoad handler to update state to loaded
  const onLoad = () => {
    // _loaded[props.src] = true;
    // console.log('cargada');
    setLoaded(true);

    setTimeout(() => {
      try {
        imageRef.current.classList.remove('opacity-0');
        imageRef.current.classList.add('opacity-100');
      } catch (err) {
        // console.log(err);
      }
    }, 1000);
  };

  let { className, loadedClassName, loadingClassName, errorElem, loadingElem } = props;

  className = `${className} ${loaded ? loadedClassName : loadingClassName}`;

  return error ? (
    <>{errorElem}</>
  ) : (
    <>
      <div
        className={+!loaded ? ' transition-opacity opacity-0 ease-in-out ' + className : 'transition-opacity opacity-100 ease-in-out ' + className}
      >
        {props.lazy ? (
          <LazyLoadImage
            src={props.src}
            ref={imageRef}
            onClick={props.onClick}
            onError={() => setError(true)}
            onLoad={onLoad}
            className='h-full w-full'
          />
        ) : (
          <img src={props.src} ref={imageRef} onClick={props.onClick} onError={() => setError(true)} onLoad={onLoad} className='h-full w-full' />
        )}
      </div>
      {!loaded ? loadingElem : null}
    </>
  );
});

ImageLoader.defaultProps = {
  className: '',
  loadingClassName: 'img-loading',
  loadedClassName: 'img-loaded',
  // loadingElem: <div className='w-full h-[125px] bg-gray-200 animate-pulse'></div>,
  errorElem: <div>Error cargando imagen</div>,
  lazy: true,
};

export default ImageLoader;
